import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { MatButtonModule } from '@angular/material/button';

import { BreadcrumbItem } from '../../../core/models/breadcrumb-item';
import { BreadcrumbService } from '../../../core/services/breadcrumb.service';
import { BreadcrumbPieceComponent } from '../breadcrumb-piece/breadcrumb-piece.component';

@Component({
	selector: 'breadcrumb-trail',
	templateUrl: './breadcrumb-trail.component.html',
	styleUrl: './breadcrumb-trail.component.scss',
	standalone: true,
	imports: [CommonModule, FontAwesomeModule, FlexLayoutModule, MatButtonModule, BreadcrumbPieceComponent]
})
export class BreadcrumbTrailComponent implements OnInit {
	public itemArray: BreadcrumbItem[] = [];

	constructor(
		private breadcrumbService: BreadcrumbService,
		private router: Router,
		private detRef: ChangeDetectorRef
	) {}

	ngOnInit(): void {
		this.breadcrumbService.breadcrumbArray.subscribe((val) => {
			this.itemArray = val; // reset the item array
			this.detRef.detectChanges();
		});
	}

	public goHome() {
		this.router.navigate(['']);
		this.breadcrumbService.resetBreadcrumbArray();
	}

	public isActiveItem(item: BreadcrumbItem): boolean {
		let isActive: boolean = false;
		if (!item.isInput && this.itemArray.at(-1).arrayIndex === item.arrayIndex) {
			isActive = true;
		} else if (this.itemArray.at(-1).isInput && this.itemArray.at(-2)?.arrayIndex === item.arrayIndex) {
			isActive = true;
		}

		return isActive;
	}

	public rebuildTrail(event: BreadcrumbItem) {
		this.breadcrumbService.rebuildBreadcrumbArray(event);
	}
}
